<template>
  <div v-if="is_GUEMAS_representative">
    <RepresentativeGuemasPanel />
  </div>
  <div v-else-if="isDental">
    <DentalDashboard />
  </div>
  <div v-else-if="is_MUTUAIDE_representative">
    <RepresentativeMutuaidePanel />
  </div>
  <div v-else-if="isTestMechanic">
    <TestMechanicPanel />
  </div>
  <div v-else class="dashboard">
    <!--<div class="breadcrumbs">-->
    <!--<div class="breadcrumbs__title">-->
    <!--<span>Vous &ecirc;tes ici : </span>-->
    <!--</div>-->
    <!--<router-link to="/dashboard" class="breadcrumbs__item">Accueil</router-link> >-->
    <!--<div class="breadcrumbs__item">Tableau de bord</div>-->
    <!--</div>-->
    <div class="block__content--table ">
      <div class="row">
        <div class="col-12">
          <div class="page__head-title page__head-title--orange">
            <div class="page__head-title__text page__head-title__text--orange">Tableau de bord</div>
          </div>
          <div class="form_ttl_first">Vos statistiques</div>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>Garantie</th>
            <th>Quantité</th>
            <th v-if="isGarden()">Primes HT</th>
            <th v-else>Prime</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(garanty, index) in garanties">
            <td>{{ garanties[index].title }}</td>
            <td>{{ garanties[index].qty }}</td>
            <td>{{ getFullPrice(garanties[index]) | formatEURWithoutSymbol | formatSeparateComma }} €</td>
          </tr>

          <tr>
            <td><b>Total</b></td>
            <td><b>{{ totalGaranties }}</b></td>
            <td><b>{{ totalPriceGaranties | formatEURWithoutSymbol | formatSeparateComma }} €</b></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="block__content--chart">
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="dougnhut-chart-wrapper">
            <div class="dougnhut-chart-wrapper__center-text">
              <p class="dougnhut-chart-wrapper__center-text--count">{{ totalPriceGaranties | formatEURWithoutSymbol |
                formatSeparateComma }} €</p>
              <p class="dougnhut-chart-wrapper__center-text--title">Total</p>
            </div>
            <canvas id="account-quotes-doughnut-chart" width="300px" height="300px"></canvas>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div class="assets-list">
            <div class="assets-list__item" v-for="garanty in garanties">
              <div class="assets-list__item--percentage">{{ garanty.qty }}</div>
              <div class="assets-list__item--title">{{ garanty.title }}</div>
              <div class="assets-list__item--border" v-bind:style="{ backgroundColor: garanty.color }"></div>
              <div class="assets-list__item--data">{{ getFullPrice(garanty) | formatEURWithoutSymbol |
                formatSeparateComma }} €</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="block__content--table ">
      <div class="row">
        <div class="col-12">
          <div class="page__head-title page__head-title--orange">
            <div class="page__head-title__text page__head-title__text--orange">Garanties souscrites</div>
            <div class="page__head-title__text__small">
              <span class="page__head-title__text__small--orange">
                (7 derniers jours)
              </span>
            </div>

          </div>
        </div>
      </div>

      <template v-if="isBusy">
        <Preloader />
      </template>
      <template v-else>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Nom</th>
              <th>Garantie souscrite</th>
              <th v-if="isGarden()">Primes HT</th>
              <th v-else>Prime</th>
              <th>Statut</th>
              <th>PDF</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="garanty in garantiesSouscrites">
              <td>{{ parseDate(garanty) }}</td>
              <td>{{ parseFullName(garanty) }}</td>
              <td>{{ parseTypeGaranty(garanty) }}</td>
              <td>{{ parsePrice(garanty) | formatSeparateComma }}</td>
              <td>{{ parseStatusGaranty(garanty) }}</td>
              <td class="pdf-icon">
                <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_pdf(garanty.id)" />
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import Chart from 'chart.js';
import Preloader from '@/components/Preloader'
import pdfPreviewMixin from '../mixins/pdfPreviewMixin';
import RepresentativeGuemasPanel from "./RepresentativeGuemasPanel";
import RepresentativeMutuaidePanel from "./RepresentativeMutuaidePanel";
import DentalDashboard from "./Dental/DentalDashboard";
import TestMechanicPanel from "./TestMechanicPanel";

export default {
  name: 'MechanicsPanel',
  components: { RepresentativeGuemasPanel, RepresentativeMutuaidePanel, DentalDashboard, Preloader, TestMechanicPanel },
  mixins: [pdfPreviewMixin],
  data() {
    return {
      doughnutChart: null,
      isBusy: true,
      garantiesSouscrites: [],
    }
  },
  computed: {
    isTestMechanic() {
      return this.$store.getters.isTest;
    },
    mechanic_id() {
      return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
    },
    representative_id() {
      return this.$store.state.userInfo.representative ? this.$store.state.userInfo.representative.id : '';
    },
    is_GUEMAS_representative() {
      return this.$store.state.userInfo.representative ? (this.$store.state.userInfo.representative.id == 12) : false;
    },
    is_MUTUAIDE_representative() {
      return this.$store.state.userInfo.representative ? (this.$store.state.userInfo.representative.owner_type == 3) : false;
    },
    isClientMonthlyPayment() {
      return this.$store.getters.isClientMonthlyPayment;
    },
    totalGaranties() {
      let totalBalance = 0;
      for (let i in this.garanties) {
        totalBalance += +this.garanties[i].qty;
      }
      return totalBalance;
    },
    totalPriceGaranties() {
      let totalBalance = 0;
      for (let i in this.garanties) {
        totalBalance += +this.garanties[i].price;
      }
      return totalBalance;
    },
    garanties() {
      //MUTUAIDE
      if (this.isMutuaide()) {
        return [
          {
            title: 'Assistance Autocars',
            qty: this.getCountGaranties('autocarQty'),
            price: this.getPriceGaranties('autocarPrice'),
            color: '#008cc9'
          },
          {
            title: 'Assistance Poids Lourds',
            qty: this.getCountGaranties('poidslourdsQty'),
            price: this.getPriceGaranties('poidslourdsPrice'),
            color: '#ff0000'
          },
          {
            title: 'Assistance Taxi/Ambulances/Corbillards',
            qty: this.getCountGaranties('vslQty'),
            price: this.getPriceGaranties('vslPrice'),
            color: '#ffb510'
          },
          {
            title: 'Assistance VU - VL',
            qty: this.getCountGaranties('vuvlQty'),
            price: this.getPriceGaranties('vuvlPrice'),
            color: '#004767'
          },
          {
            title: 'Assistance VUL - 4097',
            qty: this.getCountGaranties('vul4097Qty'),
            price: this.getPriceGaranties('vul4097Price'),
            color: '#f69638'
          },
        ];
      }
      //GARDEN
      else if (this.isGarden()) {
        return [
          {
            title: 'Garantie Tondeuse, Robot',
            // qty: this.getCountGaranties('camping-carOldQty'),
            qty: 50,
            // price: this.getPriceGaranties('camping-carOldPrice'),
            price: 3465.00,
            color: '#008cc9'
          },
          {
            title: 'Garantie Tronçonneuse',
            // qty: this.getCountGaranties('camping-carNewQty'),
            qty: 10,
            // price: this.getPriceGaranties('camping-carNewPrice'),
            price: 264.00,
            color: '#ff0000'
          },
          {
            title: 'Garantie Taille-Haie',
            // qty: this.getCountGaranties('insuranceQty'),
            qty: 30,
            // price: this.getPriceGaranties('insurancePrice'),
            price: 459.00,
            color: '#ffb510'
          },
          {
            title: 'Garantie Débroussailleuse',
            // qty: this.getCountGaranties('insuranceQty'),
            qty: 20,
            // price: this.getPriceGaranties('insurancePrice'),
            price: 310.00,
            color: '#ffb510'
          },
          {
            title: 'Garantie Elagueuse',
            // qty: this.getCountGaranties('insuranceQty'),
            qty: 18,
            // price: this.getPriceGaranties('insurancePrice'),
            price: 220.00,
            color: '#ffb510'
          },
          {
            title: 'Garantie Autres',
            // qty: this.getCountGaranties('insuranceQty'),
            qty: 70,
            // price: this.getPriceGaranties('insurancePrice'),
            price: 1750.00,
            color: '#ffb510'
          },
        ];
      }
      //DEALER
      else if (this.isDealer()) {
        return [
          {
            title: 'Garantie camping-car occasion',
            qty: this.getCountGaranties('camping-carOldQty'),
            price: this.getPriceGaranties('camping-carOldPrice'),
            color: '#008cc9'
          },
          {
            title: 'Garantie camping car neuf',
            qty: this.getCountGaranties('camping-carNewQty'),
            price: this.getPriceGaranties('camping-carNewPrice'),
            color: '#ff0000'
          },
          {
            title: 'MASTERS Assurance',
            qty: this.getCountGaranties('insuranceQty'),
            price: this.getPriceGaranties('insurancePrice'),
            color: '#ffb510'
          },
        ];
      }
      //MECHANIC
      else {
        let returnArr = [
          {
            title: 'Garantie Vp - VU - 4x4',
            qty: this.getCountGaranties('autoQty'),
            price: this.getPriceGaranties('autoPrice'),
            color: '#008cc9'
          },
          {
            title: 'Garantie Camping-Car',
            qty: this.getCountGaranties('camping-carQty'),
            price: this.getPriceGaranties('camping-carPrice'),
            color: '#ffc500'
          },
          {
            title: 'Garantie Moto',
            qty: this.getCountGaranties('motoQty'),
            price: this.getPriceGaranties('motoPrice'),
            color: '#ff0000'
          },
        ];
        if (this.isClientMonthlyPayment) {
          returnArr.push({
            title: 'Garantie Auto Mensualisée',
            qty: this.getCountGaranties('autoMonthlyQty'),
            price: this.getPriceGaranties('autoMonthlyPrice'),
            color: '#28a745'
          });
        }
        return returnArr;
      }
    },
    isDental() {
      return this.$store.getters.isDental;
    },
    isDentalRepresentative() {
      return this.$store.getters.isDental;
    }
  },
  methods: {
    isDealer() {
      return this.$store.getters.isDealer;
    },
    isBroker() {
      return this.$store.getters.isBroker;
    },
    isMutuaide() {
      return this.$store.getters.isMutuaide;
    },
    isSpecialite() {
      return this.$store.getters.isSpecialite;
    },
    isGarden() {
      return this.$store.getters.isGarden;
    },
    isRepresentative() {
      return this.$store.getters.isRepresentative;
    },
    parseDate(garanty) {
      if (garanty && garanty.created_at) {
        let day = garanty.datesParse.day_created,
          month = garanty.datesParse.month_created,
          year = garanty.datesParse.year_created;
        return day + "/" + month + '/' + year;
      }

      return ' - ';
    },
    parsePrice(garanty) {
      let price = this.getFullPrice(garanty);
      if (garanty.status == 'Credited')
        return (price > 0) ? '-' + this.roundEURWithoutSymbol(price) + ' €' : ' - '
      else
        return (price > 0) ? this.roundEURWithoutSymbol(price) + ' €' : ' - '
    },
    getFullPrice(garanty) {
      let price = garanty.price || 0;
      let assistance_price = garanty.assistance_price || 0;
      return price + assistance_price;
    },
    parseFullName(garanty) {
      if (this.isRepresentative()) {
        return (garanty && garanty.mechanic && garanty.mechanic.garage) ? garanty.mechanic.garage : ' - ';
      }
      else {
        return (garanty && garanty.client) ? garanty.client.first_name + ' ' + garanty.client.last_name : ' - ';
      }
    },
    parseTypeGaranty(garanty) {
      if (this.isGarden()) {
        if (garanty && garanty.category) {
          switch (+garanty.category) {
            case 1:
              return 'Tondeuse, Robot';
              break;
            case 2:
              return 'Tronçonneuse';
              break;
            case 3:
              return 'Taille-Haie';
              break;
            case 4:
              return 'Débrousailleuse';
              break;
            case 5:
              return 'Elagueuse';
              break;
            case 6:
              return 'Autres';
              break;
          }
        }
      }
      else {
        if (garanty.garantie_name) {
          return garanty.garantie_name;
        }
        else if (garanty && garanty.category) {
          switch (+garanty.category) {
            case 2:
              return 'Auto';
              break;
            case 3:
              return 'Moto';
              break;
            case 1:
              return this.parseTypeGarantyForDealers(garanty);
              break;
          }
        }
      }
      return '';
    },
    parseStatusGaranty(garanty) {
      if (garanty && garanty.status) {
        switch (garanty.status) {
          case 'Active':
            return 'Valide';
            break;
          case 'Inactive':
            return 'Annulée';
            break;
          case 'Expired':
            return 'Echue';
            break;
          case 'Credited':
            return 'Sans Effet';
            break;
        }
      }
      return '';
    },
    parseTypeGarantyForDealers(guaranty) {
      if (this.isDealer()) {
        return (guaranty.details.is_new.toLowerCase() === "oui") ? 'Garantie camping car neuf' : 'Garantie camping-car occasion';
      }
      return 'Camping car';
    },
    getGarantiesSouscrites() {
      if (this.mechanic_id) {
        let url;
        if (this.isDealer())
          url = 'garantie/dealer-search';
        else if (this.isMutuaide())
          url = 'garantie/mutuaide-search';
        else
          url = 'garantie/search';
        // let url = (this.isDealer()) ? 'garantie/dealer-search' : 'garantie/search';
        let filterParams = {
          start_date: this.moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          end_date: this.moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          pdf: 1,
          sort: 'id|desc',
          specialite: this.isSpecialite()
        },
          data = {
            mechanic_id: this.mechanic_id,
            ...filterParams,
          };
        this.apiGet(url, data)
          .then(response => {
            this.isBusy = false;
            this.garantiesSouscrites = response.data.data;
          })
          .catch(error => {
            this.isBusy = false;
          })
      }
    },
    getGarantiesRepresentativeSouscrites() {
      if (this.representative_id) {
        let url = 'garantie/representative-search';
        let filterParams = {
          start_date: this.moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          end_date: this.moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          pdf: 1,
          sort: 'id|desc',
        },
          data = {
            representative_id: this.representative_id,
            ...filterParams,
          };
        this.apiGet(url, data)
          .then(response => {
            this.isBusy = false;
            this.garantiesSouscrites = response.data.data;
          })
          .catch(error => {
            this.isBusy = false;
          })
      }
    },
    getCountGaranties(type) {
      return this.$store.state.quotes && this.$store.state.quotes[type] ? +this.$store.state.quotes[type] : 0;
    },
    getPriceGaranties(type) {
      return this.$store.state.quotes && this.$store.state.quotes[type] ? this.roundEURWithoutSymbol(this.$store.state.quotes[type]) : 0;
    },
    drawAccountQuotesDoughnutChart() {
      let doughnutChartContainer = $('#account-quotes-doughnut-chart'),
        data = [],
        backgroundColor = [],
        labels = [];
      for (let i in this.garanties) {

        data.push(this.garanties[i].price);
        backgroundColor.push(this.garanties[i].color);
        labels.push(this.garanties[i].title);
      }
      if (this.doughnutChart) {
        this.doughnutChart.destroy();
      }
      this.doughnutChart = new Chart(doughnutChartContainer, {
        type: 'doughnut',
        data: {
          datasets: [{
            data,
            backgroundColor,
            borderColor: 'transparent',
          }],
          labels
        },
        options: {
          animation: false,
          responsive: false,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                  currency = data.labels[tooltipItem.index];
                return currency + ': ' + this.replaceDotCommaAmount(value) + ' €';
              }
            },
            backgroundColor: 'rgba(0,0,0,1)'
          }
        }
      });
    }
  },
  watch: {
    'garanties': function () {
      this.drawAccountQuotesDoughnutChart();
    },
    'mechanic_id': function () {
      this.getGarantiesSouscrites();
    },
    'representative_id': function () {
      this.getGarantiesRepresentativeSouscrites();
    }
  },
  mounted() {
    this.drawAccountQuotesDoughnutChart();
    if (this.representative_id) {
      this.getGarantiesRepresentativeSouscrites();
    }
    else {
      this.getGarantiesSouscrites();
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/MechanicsPanel.vue